<template>
  <div class="border-2 border-gray-800">

    <AssetHeader 
      :index="index" 
      :updateValue="updateValue"
      :assetId="asset.id"
      :assetType="parseInt(asset.type)"
      :deleteAsset="deleteAsset"></AssetHeader>

    <div class="flex flex-wrap -mx-2 p-4">
      <div class="w-full lg:w-1/3 px-2">
        <div class="">
          <InputText 
            label="Make/Model"
            propertyKey="string2"
            objectType="asset"
            :index="index"
            :objectId="asset.id"
            :value="asset.string2"
            :updateValue="updateValue" />
        </div>

        <div class="mt-6">
          <div class="label-standard">Type</div>
          <div class="form-line">
            <select
              :value="asset.string1 == null ? -1 : asset.string1"
              v-on:change="updateValue({
                objectType: 'asset',
                objectId  : asset.id,
                index     : index,
                key       : 'string1',
                value     : $event.target.value
              })"
              class="select-standard">
              <option value="-1">Please select a type</option>
              <option value="Motorcycle">Motorcycle</option>
              <option value="Large Luxury Car">Large Luxury Car</option>
              <option value="4WD">4WD</option>
              <option value="Medium">Medium</option>
              <option value="Small">Small</option>
              <option value="Small Medium">Small Medium</option>
            </select>
          </div>
        </div>

        <div class="mt-6">
          <YearSelector
            propertyKey="year"
            objectType="asset"
            :index="index"
            :objectId="asset.id"
            :value="asset.year"
            :updateValue="updateValue"></YearSelector>
        </div>
      </div>

      <div class="w-full lg:w-1/3 px-2 mt-6 lg:mt-0">
        <InputDollarValue 
          propertyKey="value"
          objectType="asset"
          label="Value"
          objectSubType="vehicle"
          :required="true"
          :objectId="asset.id"
          :index="index"
          :value="asset.value"
          :updateValue="updateValue"/>
      </div>

      <div class="w-full lg:w-1/3 px-2 mt-6 lg:mt-0">
        <Ownership :asset="asset" />
      </div>
    </div>
  </div>
</template>

<script>
  
  import AssetHeader        from '../AssetHeader'
  import InputText          from '@/shared/components/form/InputText'
  import InputDollarValue   from '@/shared/components/form/InputDollarValue'
  import YearSelector       from '@/shared/components/form/YearSelector'
  import Ownership          from '@/shared/components/Ownership'

  export default {

    components: {
      AssetHeader,
      InputText,
      YearSelector,
      InputDollarValue,
      Ownership,
    },

    props : {
      asset : {
        type     : Object,
        required : true
      },

      index : {
        type : Number,
        required : false
      },

      updateValue : {
        type     : Function,
        required : false
      },

      deleteAsset : {
        type    : Function,
        required: false
      },
    },

    methods : {

      // localUpdateValue steps in between the child component and the
      // parent component in order to inject an extra argument to the 
      // update value function since for assets, we also need which
      // asset we are currently updating
      localUpdateValue(key, value) {
        this.updateValue(this.asset.id, this.index, key, value)
      }
    }
  }
</script>